import { Button, Checkbox } from "@evertrue/et-components";
import { useState, useEffect } from "react";
import { PropTypes } from "base/react-libs";
import { trackJourneysAction } from "apps/journeys/utils/helpers/mixpanel";
import TaskStatusMessage from "./task-status-message";
import CompleteTaskToggle from "apps/tasks/components/complete-task-toggle";
import JourneyContactCard from "apps/journeys/components/journey-contact-card";
import TaskRowActionButton from "./task-row-action-button";
import TaskRowOutreachButtons from "./task-row-outreach-buttons";
import FlaggedComponent from "components/flagged-component";

const TaskRow = ({
  task = {},
  step = {},
  journey = {},
  openContactSummary,
  handleCompletionClick,
  optionalStateManagementFunction = () => {},
  viewSideBar,
  tasksSelected,
  setTasksSelected,
  allSelectedTasks,
  setAllSelectedTasks,
}) => {
  const [isActive, setIsActive] = useState(false);

  useEffect(() => {
    if (!viewSideBar) {
      setIsActive(false);
    }
  }, [viewSideBar]);

  if (!task) return null;
  const { id, contact } = task || {};

  return (
    <div key={`task-record-${id}`} className={`journeys-task-table-row--details ${isActive ? "active" : ""}`}>
      <div>
        <FlaggedComponent feature="bulkCadenceMoves">
        <Checkbox
          label=""
          checked={tasksSelected.includes(task.id)}
          onChange={(checked) => {
            if (checked) {
              setTasksSelected([...tasksSelected, task.id]);
              setAllSelectedTasks([...allSelectedTasks, task.id]);
            } else {
              setTasksSelected(tasksSelected.filter((taskId) => taskId !== task.id));
              setAllSelectedTasks(allSelectedTasks.filter((taskId) => taskId !== task.id));
            }
          }}
        />
        </FlaggedComponent>
        <CompleteTaskToggle task={task} size="small" onClick={handleCompletionClick} />
        <JourneyContactCard contact={contact || {}} currentJourney={journey} />
      </div>
      <div style={{ display: "flex", gap: "15px" }}>
        <TaskStatusMessage task={task} />
        <TaskRowOutreachButtons task={task} />
        <TaskRowActionButton
          task={task}
          step={step}
          journey={journey}
          optionalStateManagementFunction={optionalStateManagementFunction}
        />
        <Button
          disabled={!task || !contact}
          onClick={() => {
            trackJourneysAction("view_link");
            openContactSummary(contact || {});
            setIsActive(true);
          }}
          type="simple"
        >
          View
        </Button>
      </div>
    </div>
  );
};

TaskRow.propTypes = {
  step: PropTypes.object.isRequired,
  journey: PropTypes.object.isRequired,
  task: PropTypes.object.isRequired,
  handleCompletionClick: PropTypes.func,
  openContactSummary: PropTypes.func,
  optionalStateManagementFunction: PropTypes.func,
  viewSideBar: PropTypes.bool,
  tasksSelected: PropTypes.array,
  setTasksSelected: PropTypes.func,
  allSelectedTasks: PropTypes.array,
  setAllSelectedTasks: PropTypes.func,
};

export default TaskRow;
